import { WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import {
  getPathnameMyResourcesDetails,
  PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID,
  PATH_MY_RESOURCES
} from "../paths";
import { useInsuranceCoverages } from "../../../query/insuranceCoverage/queries/useInsuranceCoverages";
import { WSQueries } from "../../../query/WSQuery";

export const RouteMyRedirectFromEnrollmentToDetails: React.FC<
  RouteComponentProps<
    {
      [PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID]: string;
    },
    any,
    {
      backPath?: string;
    }
  >
> = props => {
  const qInsuranceCoverages = useInsuranceCoverages(
    {
      filter: {
        sourceId: props.match.params.planEnrollmentId
      },
      page: {
        size: 2
      },
      sort: "createdAt"
    },
    {
      retry: false
    }
  );

  return (
    <WSPage>
      <WSQueries
        queries={{ qInsuranceCoverages }}
        onError={() => props.history.push(PATH_MY_RESOURCES)}
      >
        {({ qInsuranceCoveragesData }) => {
          const insurances = qInsuranceCoveragesData.pages[0];

          if (insurances.length === 1) {
            return (
              <Redirect
                to={getPathnameMyResourcesDetails(
                  "",
                  insurances[0].insuranceCoverageId
                )}
              />
            );
          }

          return <Redirect to={PATH_MY_RESOURCES} />;
        }}
      </WSQueries>
    </WSPage>
  );
};
